import React, { useEffect, useRef, useState } from "react";
import "../components/InfiniteDropdown.css";

const BATCH_SIZE = 100;

const InfiniteQuestionDropdown = ({ total, value, onChange }) => {
  const [open, setOpen] = useState(false);
  const [visibleCount, setVisibleCount] = useState(Math.min(BATCH_SIZE, total));
  const [scrollPosition, setScrollPosition] = useState(0);
  const dropdownRef = useRef(null);
  const triggerRef = useRef(null);
  const menuRef = useRef(null);
  const [openUp, setOpenUp] = useState(false);


  useEffect(() => {
    setVisibleCount(Math.min(BATCH_SIZE, total));
  }, [total]);

  // Close on outside click
  useEffect(() => {
    const handler = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        // Save scroll position before closing
        if (menuRef.current) {
          setScrollPosition(menuRef.current.scrollTop);
        }
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;

    if (scrollTop + clientHeight >= scrollHeight - 5) {
      setVisibleCount((prev) =>
        Math.min(prev + BATCH_SIZE, total)
      );
    }
  };

  const handleSelect = (item) => {
    if (menuRef.current) {
      setScrollPosition(menuRef.current.scrollTop);
    }
    onChange({ target: { value: item } });
    setOpen(false);
  };

  // Handle wheel scroll to prevent page scroll
  useEffect(() => {
    if (!open || !menuRef.current) return;

    const handleWheel = (e) => {
      const menu = menuRef.current;
      if (!menu) return;

      const { scrollTop, scrollHeight, clientHeight } = menu;
      const atTop = scrollTop === 0;
      const atBottom = scrollTop + clientHeight >= scrollHeight;

      if ((atTop && e.deltaY < 0) || (atBottom && e.deltaY > 0)) {
        e.preventDefault();
      } else {
        e.preventDefault();
        menu.scrollTop += e.deltaY;
      }
    };

    const menu = menuRef.current;
    menu.addEventListener("wheel", handleWheel, { passive: false });

    return () => {
      menu.removeEventListener("wheel", handleWheel);
    };
  }, [open]);

  useEffect(() => {
    if (!open || !triggerRef.current || !menuRef.current) return;

    const triggerRect = triggerRef.current.getBoundingClientRect();
    const menuHeight = menuRef.current.offsetHeight;

    const spaceBelow = window.innerHeight - triggerRect.bottom;
    const spaceAbove = triggerRect.top;

    setOpenUp(spaceBelow < menuHeight && spaceAbove > spaceBelow);
    
    // Restore scroll position when dropdown opens
    if (menuRef.current && scrollPosition > 0) {
      menuRef.current.scrollTop = scrollPosition;
    }
   }, [open, visibleCount, scrollPosition]);

  return (
    <div className="custom-dropdown-container">
    <div className="custom-dropdown" ref={dropdownRef}>
      <div
        className="dropdown-trigger dropdown-toggle"
        ref={triggerRef}
        onClick={() => setOpen((prev) => !prev)}
      >

        {value}
        {/* <span className="arrow-icon">▾</span> */}
      </div>

      {open && (
        <div
          ref={menuRef}
          className={`dropdown-menu-custom ${openUp ? "open-up" : ""}`}
          onScroll={handleScroll}
          style={{zIndex:"1000"}}
        >
          {Array.from({ length: visibleCount }, (_, i) => {
            const item = i + 1;
            return (
              <div
                key={item}
                className={`dropdown-item ${
                  item === value ? "active" : ""
                }`}
                onClick={() => handleSelect(item)}
              >
                {item}
              </div>
            );
          })}
        </div>
      )}
    </div><span className="total-qtn" >{`/${total}`}</span>
    </div>
  );
};

export default InfiniteQuestionDropdown;
